module.exports = __webpack_public_path__ + "img/email_confirmado.b8bd921c.jpg";